import { COMPANY_NAME_MIN_LENGTH, DEFAULT_MAX_LIMITED } from 'constants/general';
import i18next from 'i18next';
import * as yup from 'yup';

import {
  ANSWER_ID, ATTACHMENTS, COMMENT, FILE_NAME, FILE_SIZE, FILE_URL, MIME_TYPE, ORIGINAL_FILE_NAME, QUESTION_ID,
  QUESTIONNAIRE_ID, QUESTIONNAIRE_RECIPIENT_ID, QUESTIONS, RATE, REJECT_REASON, SELECTED_OPTION_ID,
} from '../../constants/formFields';

export const createMAIroQuestionnaireAnswerSchema = yup.object({
  [QUESTIONNAIRE_ID]: yup.number().optional(),

  [QUESTIONNAIRE_RECIPIENT_ID]: yup.number().optional(),

  [COMMENT]: yup.string().optional(),

  [QUESTIONS]: yup.array().of(
    yup.object().shape({
      [QUESTION_ID]: yup.number().optional(),

      answer: yup.object().shape({
        [ANSWER_ID]: yup.number().optional(),

        [RATE]: yup.number().min(1).max(7).optional(),

        [SELECTED_OPTION_ID]: yup.number().optional(),

        [REJECT_REASON]: yup
          .string()
          .transform((v) => (v == null || v === '' ? undefined : v))
          .optional()
          .min(COMPANY_NAME_MIN_LENGTH, i18next.t(
            'errors.minCharactersLength',
            { name: i18next.t('materialityAssessment.reason'), length: COMPANY_NAME_MIN_LENGTH },
          ))
          .max(DEFAULT_MAX_LIMITED, i18next.t(
            'errors.maxCharactersLength',
            { name: i18next.t('materialityAssessment.reason'), length: DEFAULT_MAX_LIMITED },
          )),
      }).optional(),
    }),
  ).optional(),

  [ATTACHMENTS]: yup.array().of(
    yup.object().shape({
      [FILE_NAME]: yup.string().optional(),

      [ORIGINAL_FILE_NAME]: yup.string().optional(),

      [MIME_TYPE]: yup.string().optional(),

      [FILE_SIZE]: yup.number().positive().optional(),

      [FILE_URL]: yup.string().url().optional(),
    }),
  ).optional(),
});

export type TCreateMAIroQuestionnaireAnswerSchema = yup.InferType<typeof createMAIroQuestionnaireAnswerSchema>;
